<template>
  <div
      class="setting-field"
      :class="{'disable-html-component': missing}">
    <el-badge
        class="label"
        :hidden="!missing"
        value="error">
      <label> {{ label }} </label>
    </el-badge>
    <span class="slider-value">{{ value }}</span>
    <el-slider
        v-model="value"
        :min="min"
        :max="max"
        :step="step"
        show-stops
        :format-tooltip="formatToolTip"
        :disabled="disabled"
        @change="onChange" />
  </div>
</template>

<script>
import { isObject, every, has, set, isArray, get } from "lodash";

export default {
  name: "SliderSetting",
  props: {
    config: {
      type: Object,
      required: true,
      validator: function (object) {
        // TODO: Inform about what key is missing (console.error)
        return (
          every(["label", "value", "path", "input"], (k) => has(object, k)) &&
          every(["min", "max"], (k) => has(object.input, k))
        );
      },
    },
  },
  data() {
    return {
      value: null,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters["auth/isAdmin"];
    },
    label() {
      return this.config.label;
    },
    min() {
      return this.config.input.min;
    },
    max() {
      return this.config.input.max;
    },
    step() {
      return this.config.input.step || 1;
    },
    path() {
      return this.config.path;
    },
    missing() {
      return get(this, "config.missing", false);
    },
    show() {
      return !get(this, "config.removed", false);
    },
    disabled() {
      return !this.isAdmin || get(this, "config.disabled", false);
    },
  },
  mounted() {
    this.value = this.config.value;
  },
  methods: {
    formatToolTip(val) {
      return get(this.config.input, ["labels", String(val)], val);
    },
    onChange(currentValue) {
      const payload = set({}, this.path, currentValue);
      this.$emit("change", {
        payload,
        done: () => (this.config.value = currentValue),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "settings";
@include settingField();
</style>
